import { createContext } from "react";
import { Domain } from "src/config/BartLambdaConfig";
import { AuthService } from "src/auth/auth-service";

export const InitDomain = createContext<{
  domain: Domain;
  setDomain: (domain: Domain) => void;
  authService: AuthService;
}>({} as any);
